/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { toolbarPlugin } from '@react-pdf-viewer/toolbar';
import { Button, Tooltip, Typography, notification } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useParams, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { get } from 'lodash';

// Import the styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { fetchProjectList } from '../../redux/CRCETechnical/action';

const { Title } = Typography;

const TechnicalPDFViewer = (props) => {
  const { id } = useParams();
  const history = useHistory();
  const { projectList, onProjectList } = props;

  console.log('TechnicalPDFViewer mounted with id:', id);
  console.log('Current pathname:', window.location.pathname);

  const [selectedTestRow, setSelectedTestRow] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    console.log('TechnicalPDFViewer component mounted');
    return () => {
      console.log('TechnicalPDFViewer component unmounted');
    };
  }, []);

  const toolbarPluginInstance = toolbarPlugin();
  const { renderDefaultToolbar, Toolbar } = toolbarPluginInstance;

  // Create a new instance of the default layout plugin
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar: (Toolbar) => <Toolbar>{renderDefaultToolbar(transform)}</Toolbar>,
  });

  const transform = (slot) => ({
    ...slot,
    // These slots will be empty
    //  Download: () => <></>,
  });

  useEffect(() => {
    // Fetch all records to find the one with matching ID
    const fetchRecord = async () => {
      try {
        const obj = {
          pageSize: 100000,
          pageNumber: 1,
        };
        await onProjectList(obj);
      } catch (error) {
        console.error('Error fetching project list:', error);
        setIsLoading(false);
      }
    };

    fetchRecord();
  }, [onProjectList]);

  useEffect(() => {
    if (projectList && projectList.length > 0) {
      // Find the record with matching ID
      const record = projectList.find((item) => item.ID === parseInt(id));
      if (record) {
        setSelectedTestRow(record);
      } else {
        // If record not found, show error
        notification.error({
          message: 'Record not found',
          description: `No record found with ID: ${id}`,
        });
      }
      setIsLoading(false);
    }
  }, [projectList, id]);

  if (isLoading) {
    return (
      <div className="flex-auto">
        <div className="d-flex mb-3 align-items-center tab-content-title">
          <div className="back_heatp_modal">
            <Tooltip title={'Back'}>
              <ArrowLeftOutlined
                onClick={() => {
                  history.push('/TechnicalPage');
                }}
              />
            </Tooltip>
          </div>
          <Title
            className="mb-0 add-new-calibration"
            level={3}
            style={{ paddingLeft: '25px', paddingTop: '5px' }}
          >
            Loading PDF Viewer...
          </Title>
        </div>
        <div className="custom-line" />
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
          }}
        >
          <div>Loading...</div>
        </div>
      </div>
    );
  }

  if (!selectedTestRow) {
    return (
      <div className="flex-auto">
        <div className="d-flex mb-3 align-items-center tab-content-title">
          <div className="back_heatp_modal">
            <Tooltip title={'Back'}>
              <ArrowLeftOutlined
                onClick={() => {
                  history.push('/TechnicalPage');
                }}
              />
            </Tooltip>
          </div>
          <Title
            className="mb-0 add-new-calibration"
            level={3}
            style={{ paddingLeft: '25px', paddingTop: '5px' }}
          >
            Record Not Found
          </Title>
        </div>
        <div className="custom-line" />
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
          }}
        >
          <div>The requested record could not be found.</div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-auto">
      <div className="d-flex mb-3 align-items-center tab-content-title">
        <Title
          className="mb-0 add-new-calibration"
          level={3}
          style={{ paddingLeft: '25px', paddingTop: '5px' }}
        >
          Report Viewer - {selectedTestRow.FileName || 'PDF Document'}
        </Title>
      </div>
      <div className="custom-line" />
      <div className="pdf-container">
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
          <Viewer
            fileUrl={selectedTestRow.FileLink}
            plugins={[defaultLayoutPluginInstance]}
          />
        </Worker>
      </div>
    </div>
  );
};

const mapStateToProps = ({ CrceTechnicalReducer }) => {
  const projectList = get(CrceTechnicalReducer, 'ProjectList', []);
  return {
    projectList,
  };
};

const mapDispatchToProps = {
  onProjectList: fetchProjectList,
};

export default connect(mapStateToProps, mapDispatchToProps)(TechnicalPDFViewer);
